import equalheightrows from '../../js/modules/equalheightgridrows.js'

export default function () {
  // including modernizr to detect @supports suppport... bacause most of the flexbox we use is inside @supports{} blocks and @supports has the worse browser support.

  // An improvement may be to include the Modernizr flexbox detect and test both but this seems to do for the present most popular browsers.
  // Another improvement would be to use Modernizr and ES6 to import this detect

  $(document).ready(function () {
    if (!Modernizr.supports) {
      equalheightrows('.grid.grid-js-equalise > [class^="griditem"]')
    }
  })
}
